import { useEffect, useState } from "react";

import { BudgetRecipientEnum, IBudgetService } from "../types";
import { ITruckerPayPlanData } from "../../../../models/truckerPayPlan";

import { fetchContractDetails } from "../../../../api/fetchContractDetails";

export const useTruckerPayPlan = (chassis: string, odometer: number, hourmeter: number, services: IBudgetService[]) => {
    const [truckerPayPlan, setTruckerPayPlan] = useState<ITruckerPayPlanData>();

    useEffect(() => {
        if (!chassis) {
            setTruckerPayPlan(undefined);
            return;
        }

        fetchContractDetails({ chassis, odometer, hourmeter } as any)
            .then(setTruckerPayPlan)
            .catch(() => setTruckerPayPlan(undefined));
    }, [chassis, odometer, hourmeter]);

    // Show the coverage balance box if we're in edit mode, the profile is MANAGER, and the budget has at least one product without coverage
    const showCoverageBalanceBox = (
        {isEditMode, isBudgetApproved, profile}: {isEditMode: boolean, isBudgetApproved: boolean, profile?: BudgetRecipientEnum}
    ): boolean => {
        const budgetHasProductWithoutCoverage = services.some(service => service.items.some(item => !item.isCovered));
        return isEditMode && !isBudgetApproved && profile === BudgetRecipientEnum.MANAGER && budgetHasProductWithoutCoverage;
    }

    const hasCoverageBalance = 
        !!(truckerPayPlan?.coverageBalance && 
        truckerPayPlan.coverageBalance > 0 && 
        services.reduce((total, service) => total + service.subtotal, 0) > 0)
    ;

    return {
        showCoverageBalanceBox,
        data: truckerPayPlan,
        hasCoverageBalance,
    }
}